







import { Vue, Component, Prop } from 'vue-property-decorator';
import { CustomFieldIcon } from '@/config/custom.conf.ts';

/**
 * 自定义字段展示列表
 *
 * @author liyuyao
 * @date 03/12/2020
 */
@Component
export default class FieldIcon extends Vue {
    @Prop({
        default: () => {
            return {
                name: '单行文本',
                type: '1',
                inputType: 'SINGLE_LINE_TEXT',
                defaultValue: '',
                isRequired: false,
                isHidden: false,
                validator: ''
            };
        }
    })
    field: CommonTypes.customField;

    customFieldIcon: CommonTypes.mapObject = CustomFieldIcon;
}
